export default __webpack_public_path__ + "static/media/Top_Bar.62964098.png";